import React, { useState } from 'react';
import { Button, message, Input, InputNumber } from 'antd';
import BaseDragAndDropUpload from '../../upload/base_dnd_upload';

const ImageModal = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { handleInsertImage, setGModal } = props;

  const [state, setState] = useState({
    imageId: '',
    src: '',
    width: 600,
    height: 400,
  });

  const styles = {
    container: {
      display: 'flex',
      width: '50rem',
      // height: '22rem',
      // flex: 1,
      // height: '100%',
      flexDirection: 'column',
      background: '#FFF',

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    row: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 10,
    },
  };
  return (
    <div style={{ ...styles.container }}>
      {contextHolder}
      <div
        style={{
          ...styles.row,
          justifyContent: 'flex-start',
          marginTop: 10,
        }}
      >
        <div style={{ width: '20%' }}>{`이미지 경로`}</div>
        <div style={{ width: '80%' }}>
          <BaseDragAndDropUpload
            width={376}
            height={140}
            contentComponent={() => (
              <div style={{ ...styles.upload_title }}>
                {`이미지를 드래그 앤 드롭`}
                <br />
                {`또는 위 아이콘을 클릭하여`}
                <br />
                {`이미지 파일 선택 후 업로드`}
              </div>
            )}
            setUploadFile={(args) => {
              // const fileName = args.name || '';
              const photo_path = args.response?.payload?.files[0].path || '';
              const photo_ext = args.response?.payload?.files[0].ext || 'png';
              const imageId = args.response?.payload?.files[0].id || '';

              setState((prev) => {
                return {
                  ...prev,
                  imageId,
                  src: `https://cdn.humanb.kr/${photo_path}/${imageId}.${photo_ext}`,
                };
              });
            }}
          />
          <div style={{ marginTop: 10 }}>{state.src || ''}</div>
        </div>
      </div>
      <div style={{ ...styles.row }}>
        <div style={{ width: '20%' }}>{`이미지 넓이`}</div>
        <InputNumber
          min={100}
          max={1024}
          defaultValue={120}
          style={{ width: '80%' }}
          onChange={(e) => {
            setState((prev) => {
              return {
                ...prev,
                width: String(e).trim(),
              };
            });
          }}
        />
      </div>
      <div style={{ ...styles.row }}>
        <div style={{ width: '20%' }}>{`이미지 높이`}</div>
        <InputNumber
          min={100}
          max={1024}
          defaultValue={80}
          style={{ width: '80%' }}
          onChange={(e) => {
            setState((prev) => {
              return {
                ...prev,
                height: String(e).trim(),
              };
            });
          }}
        />
      </div>
      <div style={{ ...styles.row, justifyContent: 'flex-end' }}>
        <Button
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
          }}
        >{`취소`}</Button>
        <Button
          type="primary"
          style={{ marginLeft: 10 }}
          onClick={(e) => {
            if (!state.src) {
              messageApi.error('이미지 경로를 입력해 주세요.');
              return;
            }
            if (state.width <= 0 || state.height <= 0) {
              messageApi.error('이미지 사이지를 등록해주세요.');
              return;
            }

            handleInsertImage({
              src: state.src,
              width: state.width,
              height: state.height,
              imageId: state.imageId,
            });

            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
          }}
        >{`추가`}</Button>
      </div>
    </div>
  );
};

export default ImageModal;
